module.exports = __webpack_public_path__ + "images/shortlease341434187d56bd80611ce029dac75b2f.png";